import usePageMeta from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import LatestSection from "@/pages/home/components/LatestSection";
import PopularSection from "@/pages/home/components/PopularSection";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  usePageMeta({
    title: "热情的邻居—热门影视剧集与精彩剧情介绍",
    description:
      "热情的邻居网站提供最新影视剧集信息、剧情介绍及相关影视内容，满足用户对热情的邻居相关影视作品的全面了解和追踪需求。",
    keywords: "热情的邻居,影视剧,剧情介绍,电视剧集,影视内容,影视信息,热门影视,影视推荐",
  });

  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryQuickLinks />
      <LatestSection />
      <PopularSection />
      <SiteIntro />
    </div>
  );
}